<div class="send-dialog">

  <div class="ui-g-12 p-zero dialog-header m-0">
    <div class="send-dialog-heading">Send {{title}}</div>
    <i class="fal fa-times fa-sm dialog-close" (click)="handleClose({})"></i>
  </div>

  <div class="ui-g-12 dialog-body" #sendDialog>
    <div class="ui-g-12 p-0 flex-start-start">
      <!-- Start Left Panel -->
      <div class="p-zero left-box">
        <div class="">
          <p class="mb-1 font-600">Recipient</p>
          <div class="recipient flex-column flex-center-start position-relative">
            <span class="font-12 font-600 text-ellipse">{{customer.displayName}}</span>
            <div class="globe-icon" (click)="switchLanguage()" *ngIf="companyLocalization">
              {{currentLang?.toUpperCase()}}
              <i class="fa fa-globe fa-globe" aria-hidden="true"></i>
            </div>
          </div>
        </div>

        <div class="mt-3">
          <p class="mb-1 font-600">Subject</p>
          <div class="subject">
            <input type="text" placeholder="Subject" [(ngModel)]="subject" class="font-13">
          </div>
        </div>

        <div class="mt-3">
          <p class="mb-1 font-600">Message</p>
          <div class="message pr-0">
            <textarea name="content" autocomplete="off" autocorrect="off" spellcheck="false" id="" cols="30"
              [(ngModel)]="content" rows="5" placeholder="Message" class="font-13"></textarea>
          </div>
        </div>
      </div>
      <!-- End Left Panel -->

      <!-- Start Right Panel -->
      <div class="p-zero right-box flex-column">
        <!-- Contact preferrence -->
        <div class="contact-btn d-flex">
          <app-outline-icon-btn id="send-dialog-email" class="mr-2" label="Email" icon="fal fa-envelope"
            [active]="isEmailSelected" (handleClick)="toggleActiveState('isEmailSelected', $event)">
          </app-outline-icon-btn>

          <app-outline-icon-btn id="send-dialog-phone" label="SMS" icon="fal fa-mobile" [active]="isSMSSelected"
            (handleClick)="toggleActiveState('isSMSSelected', $event)">
          </app-outline-icon-btn>
        </div>

        <!-- Notification -->
        <div class="notification-contact-box flex-column flex-center-start mt-2 position-relative"
          tooltipStyleClass="ticket-tooltip modifier apt-tooltip completed" tooltipPosition="right"
          [pTooltip]="notificationRecipientTooltip" [escape]="false">
          <i class="far fa-edit pointer p-2 update-recipient-icon" tooltipPosition="top"
            [ngClass]="{'not-allowed': !isEmailSelected && !isSMSSelected}"
            [pTooltip]="!isEmailSelected && !isSMSSelected? 'Select Email or Phone to add Recipients': ''"
            (click)="openUpdateRecipientDialog('confirmation')"></i>

          <div class="width-100p flex-start-center font-13">
            <i class="fal fa-bell font-gray-85 contact-icon flex-center-center"></i>
            <span class="font-bold">Notification</span>
          </div>

          <div class="flex-start-center font-12">
            <i class="fal fa-envelope font-gray-85 contact-icon flex-center-center"></i>
            <span *ngIf="recipients?.emails?.length === 1 ">
              {{recipients?.emails[0].value}}
            </span>

            <span *ngIf="recipients?.emails?.length !== 1">
              <span *ngIf="!recipients?.emails?.length">No email</span>
              <span *ngIf="recipients?.emails?.length">{{recipients?.emails?.length}} email addresses</span>
            </span>
          </div>

          <div class="flex-start-center font-12">
            <i class="fal fa-mobile font-gray-85 contact-icon flex-center-center"></i>
            <span *ngIf="recipients?.phones?.length === 1">
              {{recipients?.phones[0].value| mask: '(000) 000-0000'}}
            </span>

            <span *ngIf="recipients?.phones?.length !== 1">
              <span *ngIf="!recipients?.phones?.length">No phone</span>
              <span *ngIf="recipients?.phones?.length">{{recipients?.phones?.length}} mobile numbers</span>
            </span>
          </div>
        </div>

        <!-- Reminders -->
        <div class="ui-g-12 p-zero mt-2 font-13 invoices-box">
          <div class="flex-start-center mb-1">
            <p class="m-0 flex-start-center">
              <span><i class="far fa-receipt pr-2"></i></span>
              <span>{{sendType === 'payment'? 'Receipts' : 'Invoices'}}</span>
            </p>
          </div>

          <div class="flex-between-center" *ngFor="let invoice of statement?.invoices;">
            <p class="m-0 flex-start-center">
              <span><i class="far fa-receipt pr-2 font-gray-65"></i></span>
              <span>RO# {{invoice?.code}} - {{invoice?.title}}</span>
            </p>
            <p class="m-0" *ngIf="sendType === 'payment'">{{invoice?.paid || 0 | currency: usd}}</p>
            <p class="m-0" *ngIf="sendType !== 'payment'">{{invoice?.unpaid || 0 | currency: usd}}</p>
          </div>

          <div class="flex-between-center">
            <p class="m-0 font-600">
              <span class="invisible"><i class="far fa-receipt pr-2 font-gray-65"></i></span>
              <span>{{sendType === 'payment'? 'Paid amount' : 'Balance due'}}</span>
            </p>
            <p class="m-0" *ngIf="sendType === 'payment'">{{totalPaid || 0 | currency: usd}}</p>
            <p class="m-0" *ngIf="sendType !== 'payment'">{{totalDue || 0 | currency: usd}}</p>
          </div>
        </div>

        <!-- Notification -->
        <div class="notification-contact-box flex-column flex-center-start mt-2 position-relative"
          *ngIf="previousStatements && previousStatements.length > 0 && !hideUnPaidStatement">

          <div class="width-100p flex-start-center font-13">
            <i class="font-width-10 font-12 flex-center-center contact-icon fal mb-1 mt-1"
              (click)="toggleAccordianState()"
              [ngClass]="{ 'fa-chevron-right': !isCheckedPreviousUnpaidStatement,'fa-chevron-down': isCheckedPreviousUnpaidStatement }"></i>
            <span class="font-bold">Include previous unpaid statements</span>
          </div>
          <div class="font-13" *ngIf="isCheckedPreviousUnpaidStatement" id="send-statement-popup">
            <div *ngFor="let previousStatement of previousStatements" class="mt-1">
              <app-checkbox [label]="previousStatement && previousStatement.name" [fontSize]="14"
                inputId="send-statement-popup" (appChange)="onSelectStatement(previousStatement,$event)"
                [isChecked]="previousStatement && previousStatement.isChecked">
              </app-checkbox>
            </div>
          </div>
        </div>
      </div>
      <!-- End Right Panel -->
    </div>
  </div>

  <div class="ui-g-12 p-zero dialog-footer">
    <div class="ui-g-6 p-zero mt-2 flex-start-center font-primary" (click)="downloadPdf()">
      <i class="fal fa-file-pdf pr-2"></i>
      <div class="customer-preview m-0 pr-2">
        {{ sendType === 'payment'? 'Download receipts PDF' : 'Download invoice statement PDF' }}
      </div>
      <i class="fal fa-spinner rotate" *ngIf="isDownloadingPdf"></i>
    </div>

    <div class="ui-g-6 p-zero text-right">
      <input id="send-dialog-btn-cancel" type="button" (click)="handleClose({})" value="Cancel"
        class="btn btn-white btn-border pointer btn-submit mr-1">

      <button id="send-dialog-btn-send" class="btn btn-primary btn-submit" [disabled]="isSendingStatement"
        (click)="onSubmit()">
        <span [ngClass]="{ 'pr-2': isSendingStatement }">Send</span>
        <i *ngIf="isSendingStatement" class="far fa-spinner rotate"></i>
      </button>
    </div>
  </div>
</div>